// extracted by mini-css-extract-plugin
module.exports = {"fixed":"navTab_fixed_nmIcz","placeholder":"navTab_placeholder_2Sj9V","navtab":"navTab_navtab_18_I6","active":"navTab_active_1Kj_x"};